



































































































import { Component, Emit, Prop, Mixins } from "vue-property-decorator"
import DatePicker from "@/components/DatePicker.vue"
import api from "../honcierge-api"
import ProcessingMixin from "../mixins/processing-mixin"
import {
  Status,
  ArticleSearchForm as Form,
  Nullable,
  Editor,
  Writer,
  Category,
  AppAffiliate,
  Article,
  SearchResultArticle,
  SelectedArticle,
  ArticleSearchParams,
} from "types/index"

@Component({
  components: { DatePicker },
})
export default class ArticleSearchForm extends Mixins(ProcessingMixin) {
  @Prop({ default: true })
  private enableTitle!: boolean
  @Prop({ default: true })
  private enableStatus!: boolean
  @Prop({ default: true })
  private enableWriter!: boolean
  @Prop({ default: true })
  private enableEditor!: boolean
  @Prop({ default: true })
  private enableCategory!: boolean
  @Prop({ default: true })
  private enableAppAffiliate!: boolean
  @Prop({ default: true })
  private enableDatePicker!: boolean
  @Prop({ default: false })
  private enableRelatedArticle!: boolean
  @Prop({ default: false })
  private enableDownloadButton!: boolean
  @Prop({ default: true })
  private enableLoginUserFilter!: boolean

  @Prop()
  private fields!: [] // 検索結果に含める項目
  @Prop()
  private articles!: []

  @Prop()
  private masterStatuses!: Status[]
  @Prop()
  private masterEditors!: Editor[]
  @Prop()
  private masterWriters!: Writer[]
  @Prop()
  private masterCategories!: Category["view"][]
  @Prop()
  private masterAppAffiliates!: AppAffiliate[]

  private lastUpdatedFrom = "最終更新日(from)"
  private lastUpdatedTo = "最終更新日(to)"
  private publishedAtFrom = "公開日(from)"
  private publishedAtTo = "公開日(to)"

  // 検索用フォーム
  private form: Nullable<Form> = {
    title: null,
    status: null,
    writerId: null,
    editorId: null,
    categoryId: null,
    appAffiliateId: null,
    updatedAtFrom: null,
    updatedAtTo: null,
    publishedAtFrom: null,
    publishedAtTo: null,
  }

  private result: SearchResultArticle[] = []

  public searchParams(
    page = 1,
    per = -1,
    sortBy = "id",
    descending = false
  ): ArticleSearchParams {
    const params = {}
    Object.assign(params, this.form)
    if (
      this.enableRelatedArticle &&
      this.articles &&
      this.articles.length > 0
    ) {
      Object.assign(params, {
        excludeArticleIds: this.articleIds(this.articles),
      })
    }
    Object.assign(params, { sortBy, descending, page, per })
    Object.assign(params, { fields: this.fields })
    Object.assign(params, { isAll: !this.enableLoginUserFilter }) // ログインユーザーによるフィルタリングを行わない
    return params
  }

  public changeDate(newDate: string, label: string): void {
    if (label === this.lastUpdatedFrom) {
      this.form.updatedAtFrom = newDate
    } else if (label === this.lastUpdatedTo) {
      this.form.updatedAtTo = newDate
    } else if (label === this.publishedAtFrom) {
      this.form.publishedAtFrom = newDate
    } else if (label === this.publishedAtTo) {
      this.form.publishedAtTo = newDate
    }
  }

  @Emit("searchResult")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public searchResult(result: SearchResultArticle[], totalPages: number): void {
    /* */
  }
  @Emit("resetPagination")
  public emitResetPagination(): void {
    /* */
  }
  @Emit("resetSelection")
  public emitResetSelection(): void {
    /* */
  }

  public search(
    page = 1,
    per = -1,
    sortBy = "id",
    descending = false,
    reset = false
  ): void {
    const params = this.searchParams(page, per, sortBy, descending)

    this.startProcess()
    api
      .getArticles(params)
      .then((res) => {
        this.result.length = 0
        res.data.articles.forEach((article: Article) => {
          this.result.push(
            this.fields.reduce((acc, field) => {
              acc[field] = article[field]
              return acc
            }, {} as SearchResultArticle)
          )
        })
        this.searchResult(
          res.data.articles.length > 0 ? this.result : [],
          res.data.meta.totalPages
        )
        if (reset) {
          this.emitResetPagination()
          this.emitResetSelection()
        }
      })
      .catch(() => {
        this.$toasted.error("データの取得に失敗しました")
      })
      .finally(() => this.endProcess())
  }

  public download(): void {
    this.startProcess()
    const params = this.searchParams(1, 25, "", false)
    api
      .downloadArticles(params)
      .then((response) => {
        const csv = response.data
        const blob = new Blob([csv], { type: "text/csv" })
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = "articles.csv"
        link.click()
      })
      .catch((error) => {
        console.log(error)
        this.$toasted.error("ダウンロードに失敗しました")
      })
      .finally(() => this.endProcess())
  }

  public reset(): void {
    const form = this.$refs.articleSearchResetForm as InstanceType<
      typeof HTMLFormElement
    >
    form.reset()
  }

  private articleIds(articles: SelectedArticle[]) {
    return articles.map((article) => article.id)
  }
}
